import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
const names = ['Carolina', 'Julieta', 'Mariana', 'Agustina', 'Sofía', 'Valentina', 'Luciana', 'Camila', 'Florencia', 'María José', 'Daniela', 'Paula', 'Romina', 'Natalia', 'Andrea'];
const cities = ['Córdoba', 'CABA', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showPopup();
      // Set interval for subsequent popups (every 8-12 seconds)
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 4000) + 8000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-289">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-50 bg-white rounded-lg shadow-2xl border border-gray-200 p-3 md:p-4 max-w-xs md:max-w-sm flex items-center gap-3" data-id="element-290">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-291">
            <ShoppingCartIcon className="w-5 h-5 md:w-6 md:h-6 text-green-600" data-id="element-292" />
          </div>
          <div data-id="element-293">
            <p className="text-xs md:text-sm text-gray-800 font-medium leading-tight" data-id="element-294">
              <span className="font-bold" data-id="element-295">{currentPurchase.name}</span> de{' '}
              {currentPurchase.city} acaba de comprar el Kit Completo
            </p>
            <p className="text-[10px] md:text-xs text-gray-500 mt-1" data-id="element-296">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}